module.exports = __webpack_public_path__ + "img/1594.e63156b4.gif";